import { Provider } from "react-redux";
import { store } from "./store";
import { RouterProvider } from "react-router-dom";
import { router } from "./Routes";
import BreakpointsProvider from "./providers/BreakpointsProvider";
import { AuthProvider } from "./providers/AuthProvider";

import "./styles/shared-styles.scss";
import "./styles/cabinet.scss";
import "./styles/partner-wallet-history.scss";

function App() {
  return (
    <Provider store={store}>
      <BreakpointsProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </BreakpointsProvider>
    </Provider>
  );
}

export default App;
